import React from "react";
import { Route, Redirect } from "react-router-dom";

export default function PrivateRoute({
    component: Component,
    authenticated,
    user,
    ...rest
}) {
    return (
        <Route
            {...rest}
            render={props =>
                authenticated === true && user && user.emailVerified ? (
                    <Component {...props} {...rest} />
                ) : (
                        <Redirect to="/" />
                    )
            }
        />
    );
}


// WEBPACK FOOTER //
// ./src/routes/ProtectedRoutes.js